import { authHeader, ApiConfigs } from "../_helpers";

export const resellerService = { 
    getAll,
    getById,
    refresh,
    create,
    update,
    filterOrganizations,
    filterBusinesses,
    grantAccess
}

function getAll(payload) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.reseller.getAll}`, requestOptions).then(handleResponse).catch(handleError);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader(),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.reseller.getById.replace(':id', id)}`, requestOptions).then(handleResponse).catch(handleError);
}

function create(payload) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: authHeader(),
        body: payload
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.reseller.create}`, requestOptions).then(handleResponse).catch(handleError);
}

function refresh(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader(),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.reseller.refreshKey.replace(':id', id)}`, requestOptions).then(handleResponse).catch(handleError);
}

function update(payload, id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: authHeader(),
        body: payload
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.reseller.update.replace(':id', id)}`, requestOptions).then(handleResponse).catch(handleError);
}

function filterOrganizations(keyword) {
    let queryParams = {
        limit: 5,
        autocomplete: "on"
    }
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader(),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.organization.search.replace(':keyword', keyword) + '?' + new URLSearchParams(queryParams)}`, requestOptions).then(handleResponse).catch(handleError);
}

function filterBusinesses(keyword) {
    let queryParams = {
        limit: 7,
        append: "rating"
    }
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader(),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.business.search.replace(':keyword', keyword) + '?' + new URLSearchParams(queryParams)}`, requestOptions).then(handleResponse).catch(handleError);
}

function grantAccess(payload, id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: authHeader(),
        body: payload
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.reseller.grantAccess.replace(':id', id)}`, requestOptions).then(handleResponse).catch(handleError);
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

function handleError(response) {
    console.log(response);
}